import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import HeaderMenu from "./components/HeaderMenu/HeaderMenu";

const { Content } = Layout;

function AppLayout() {
  return (
    <Layout style={{ height: "100vh" }}>
      <HeaderMenu />
      <Content
        style={{
          height: "calc(100vh - 64px)",
          minHeight: 500,
          overflowY: "auto",
          position: "relative",
          backgroundColor: "white",
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
}

export default AppLayout;
